import { colorStyles, weights } from "./data";

export const cleanData = (rawJSDocData: any) => {
  const formattedRaw: any[] = [];
  rawJSDocData.blocks.forEach((block: any) => {
    const { type: blockStyle, text, inlineStyleRanges } = block;
    const formattedText = formatTextBlock(text, inlineStyleRanges);

    formattedRaw.push({
      blockStyle,
      text: formattedText,
    });
  });

  // console.log(formattedRaw)

  return formattedRaw;
};




// Helper function to get character styles for a given index
const getCharStyles = (index: number, inlineStyleRanges: any[], colorStyles: any) => {
  const charStyles = {
    bold: false,
    italic: false,
    underline: false,
    color: '',
    weight: '',
  };

  inlineStyleRanges.forEach((range: any) => {
    const { offset, length, style } = range;
    if (index >= offset && index < offset + length) {
      // if (style.includes('BOLD')) charStyles.bold = true;
      // if (style.includes('ITALIC')) charStyles.italic = true;
      // if (style.includes('UNDERLINE')) charStyles.underline = true;

      weights.forEach((weight: any) => {
        if (weight.class === style) charStyles.weight = style
      })
      colorStyles.forEach((color: any) => {
        if (color.nameCamel === style) charStyles.color = style;
      });
    }
  });

  return charStyles;
};




// Helper function to push formatted text with styles into the result
const pushFormattedText = (buffer: string, currentStyle: any, formattedText: any[]) => {
  if (buffer === '') return;

  const cleanedCharStyles = Object.keys(currentStyle).reduce((acc: any, key) => {
    if (currentStyle[key] !== false) acc[key] = currentStyle[key];
    return acc;
  }, {});

  formattedText.push({
    characters: buffer,
    ...cleanedCharStyles,
  });
};



// Main function to format each text block with inline styles
const formatTextBlock = (text: string, inlineStyleRanges: any[]) => {
  const formattedText: any[] = [];
  let currentStyle: any = {};
  let charBuffer = '';

  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    const charStyles = getCharStyles(i, inlineStyleRanges, colorStyles);

    // Check if style has changed
    if (JSON.stringify(charStyles) !== JSON.stringify(currentStyle)) {
      pushFormattedText(charBuffer, currentStyle, formattedText);
      currentStyle = charStyles;
      charBuffer = char;
    } else {
      charBuffer += char;
    }
  }

  // Push any remaining characters in the buffer
  pushFormattedText(charBuffer, currentStyle, formattedText);

  return formattedText;
};
